import axios from "axios";
import { Project } from "../interfaces/Project";

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';

export abstract class API {

    public static API_END_POINT : string = _API_END_POINT;

    public static loginUser(email: string, password : string) {
        return axios.post(API.API_END_POINT + "/login", {
            email,
            password
        }, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static getUser(token : string){
        return axios.get(API.API_END_POINT + "/user", {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }


    public static getProjects(token: string){
        return axios.get(API.API_END_POINT + "/projects", {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static registerUser(name : string, email: string, password : string, company: string) {
        return axios.post(API.API_END_POINT + "/register", {
            email,
            password,
            company,
            name
        }, {
            headers: {
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static createProject(token: string, data : Project) {
        return axios.post(API.API_END_POINT + "/projects", data, {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static createEquipment(token: string, name: string, siteId) {
        return axios.post(API.API_END_POINT + "/equipment", {
            name,
            siteId
        }, {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }
    
    public static getEquipment(token: string){
        return axios.get(API.API_END_POINT + "/equipment", {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static getUsers(token: string){
        return axios.get(API.API_END_POINT + "/users", {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static createUser(token: string, username: string, password: string, email : string){
        return axios.post(API.API_END_POINT + "/users", {
            username,
            password,
            email,
        }, {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }


    public static deleteUser(token : string, id){
        return axios.delete(API.API_END_POINT + "/users/" + id, {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static acceptInvite(email : string, password : string, inviteCode : string){
        return axios.post(API.API_END_POINT + "/invitation/accept/" + inviteCode, {
            password,
            email,
        }, {
            headers: {
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }

    public static getContractors(token: string){
        return axios.get(API.API_END_POINT + "/contractors", {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"
            }
        })
        .then((request) => request.data);
    }    

    public static createContractor(token, payload){
        return axios.post(API.API_END_POINT + "/contractors", payload, {
            headers: {
                Authorization:  "Bearer " + token,
                "content-type": "application/json"            
            }
        })
        .then((request) => request.data);
    }

    

    
}
